import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query'

import { useGetNetworkMembersQuery, useGetNetworkQuery } from '@/core/services/network'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

import MembersTable from '../components/MembersTable'
import { NetworkMemberAccessLevel } from '@/core/models/network.model'
import _ from 'lodash'

export default function MembersTableContainer() {
  const { networkId } = useParams()

  const authUser = useAppSelector(selectAuthUser)

  const { data: network } = useGetNetworkQuery(networkId ?? skipToken)
  const { data } = useGetNetworkMembersQuery(networkId ?? skipToken, { refetchOnMountOrArgChange: true })

  const networkMembers = useMemo(() => _.filter(data, (item) => !!item?.member), [data])

  const membersData = useMemo(
    () =>
      networkMembers?.map(({ accessLevel, invitedBy, member }) => ({
        id: member._id,
        canLeave: true,
        canRemove: member._id !== network?.createdBy._id && authUser?._id === network?.createdBy._id,
        canPromote: member._id !== network?.createdBy._id && authUser?._id === network?.createdBy._id,
        email: member.email,
        establishment: member.establishment?.name,
        invitedBy: invitedBy ? `${invitedBy.userInfo.name} ${invitedBy.userInfo.surname}` : '',
        name: `${member.userInfo.name} ${member.userInfo.surname}`,
        role: accessLevel.toLowerCase(),
        isAdmin: accessLevel === NetworkMemberAccessLevel.ADMIN,
      })) ?? [],
    [authUser, network, networkMembers]
  )

  return <MembersTable data={membersData} />
}
